<template>
  <div class="page">
    <el-card>
      <div slot="header" class="clearfix">
        <span>预约受理</span>
        <el-button type="primary" size="small" style="float:right" @click="fetchList">
          刷新
        </el-button>
      </div>

      <!-- 🔍 查询区域 -->
      <el-form :inline="true" :model="query" class="filter-bar" @submit.native.prevent>
        <el-form-item label="用户ID">
          <el-input
            v-model="query.user_id"
            placeholder="输入用户ID"
            clearable
            style="width: 180px"
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            v-model="query.status"
            placeholder="全部"
            clearable
            style="width: 160px"
          >
            <el-option label="全部" value="" />
            <el-option label="待审核" value="waiting_audit" />
            <el-option label="已通过" value="approved" />
            <el-option label="已拒绝" value="rejected" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="pagedList"
        border
        stripe
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column prop="id" label="预约ID" width="80" />
        <el-table-column prop="name" label="联系人" width="120" />
        <el-table-column prop="contact" label="电话" width="130" />
        <el-table-column prop="addr" label="地址" min-width="200" show-overflow-tooltip />
        <el-table-column prop="metal_type" label="金属类型" width="100" />
        <el-table-column prop="weight" label="重量(kg)" width="100" />
        <el-table-column prop="appointment_time_text" label="预约时间" width="180" />
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.status)">
              {{ statusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="图片" width="120">
          <template slot-scope="{ row }">
            <el-image
              :src="row.image_url"
              style="width: 60px; height: 60px; border-radius: 4px;"
              fit="cover"
              :preview-src-list="[row.image_url]"
            />
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />

        <!-- ✅ 审核操作列 -->
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="{ row }">
            <!-- 只有待审核才显示按钮 -->
            <el-button
              v-if="row.status === 'waiting_audit'"
              type="success"
              size="mini"
              @click="audit(row, 'approve')"
            >
              通过
            </el-button>
            <el-button
              v-if="row.status === 'waiting_audit'"
              type="danger"
              size="mini"
              @click="audit(row, 'reject')"
            >
              拒绝
            </el-button>
            <!-- 已审核显示结果 -->
            <span v-if="row.status === 'approved'" style="color:#67c23a;">已通过</span>
            <span v-if="row.status === 'rejected'" style="color:#f56c6c;">已拒绝</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-box">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.length"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Appointment',
  data() {
    return {
      loading: false,
      list: [],
      currentPage: 1,
      pageSize: 10,
      query: {
        user_id: '',
        status: ''
      }
    }
  },
  computed: {
    pagedList() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.list.slice(start, start + this.pageSize)
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    // 列表接口
    async fetchList() {
      this.loading = true
      try {
        const res = await axios.get('https://wx.hzxcet.com/api/appointment/list', {
          params: {
            user_id: this.query.user_id || undefined,
            status: this.query.status || undefined
          }
        })
        if (res.data.code === 0) {
          this.list = res.data.data || []
          this.currentPage = 1
        } else {
          this.$message.error(res.data.msg || '获取失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('接口请求失败')
      } finally {
        this.loading = false
      }
    },

    handleSearch() {
      this.currentPage = 1
      this.fetchList()
    },
    handleReset() {
      this.query = { user_id: '', status: '' }
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handlePageChange(val) {
      this.currentPage = val
    },

    statusText(status) {
      return {
        waiting_audit: '待审核',
        approved: '已通过',
        rejected: '已拒绝'
      }[status] || status
    },
    statusTagType(status) {
      return {
        waiting_audit: 'warning',
        approved: 'success',
        rejected: 'danger'
      }[status] || 'info'
    },

    // ✅ 审核接口：通过 / 拒绝
    async audit(row, action) {
      const actionText = action === 'approve' ? '通过该预约并生成订单' : '拒绝该预约'
      try {
        await this.$confirm(
          `确认要${actionText}吗？`,
          '提示',
          { type: 'warning' }
        )
      } catch (_) {
        // 用户点了取消
        return
      }

      try {
        this.loading = true
        const res = await axios.post('https://wx.hzxcet.com/api/appointment/audit', {
          id: row.id,
          action, // "approve" 或 "reject"
          province:'xinjiang',
          city:'bozhou',
          district:'bole'
        })

        if (res.data.code === 0) {
          // 前端直接更新当前行状态
          row.status = action === 'approve' ? 'approved' : 'rejected'
          this.$message.success(res.data.msg || '操作成功')
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('审核接口请求失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.page {
  padding: 10px;
}
.filter-bar {
  margin-bottom: 10px;
}
.pagination-box {
  margin-top: 16px;
  text-align: right;
}
</style>
